import { theme } from 'Assets/Styles/theme'

export default ({ props }) => {
  const accentColor = props.color || theme.colors.primary

  return {
    confirmBodyPopup: {
      width: 200,
    },
    infoBlock: {
      marginBottom: '10px',
    },
    underline: {
      textDecoration: 'underline',
    },

    confirmModal: {
      maxWidth: '500px',
    },

    designsPreview: {
      display: 'flex',
      marginTop: '20px',
      justifyContent: 'space-between',
      '&>*:not(:last-child)': {
        marginRight: '20px',
      },
    },
    flyerPage: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    button: {
      '&:not(:last-child)': {
        marginRight: 20,
      },
    },
    filledButton: {
      borderRadius: '4px',
      backgroundColor: accentColor,
      color: theme.colors.white,
      letterSpacing: '0.8px',
      filter: 'brightness(1)',
      transition: 'filter .3s',
      '&:hover': {
        backgroundColor: accentColor,
        filter: 'brightness(1.3)',
      },
    },
  }
}
